import { Component, OnInit } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {Route, ActivatedRoute, Params} from '@angular/router';
import { Router } from '@angular/router';
import { UtilsService } from '../../shared/utils-service';

@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrls: ['./view-user.component.css']
})
export class ViewUserComponent implements OnInit {

private userId: string = '';
private users: any = [];
private urlView: string;
private viewData: any = [];
private editMember: any = {};
loggedInUser: any = {};
weekDays: any = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
private url: string = this.utils.url+"/ddmf_backoff/users/";
private userStatusDescription: string='';//DDMF-101
  constructor(private http: Http, private activatedRoute: ActivatedRoute, private router: Router, private utils: UtilsService) { 
    this.loggedInUser = this.utils._checkSession({'page': 'manage-users'});
  }
  
  
  viewUser(user){
  
  this.users=user;
  //debugger;
  
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
        this.userId = params['name'];
        console.log(params);
      });
    this.getData().subscribe(data => {
        this.users = data['_body'];
        this.users = JSON.parse(this.users);
        //DDMF-101 : Start
        if(this.users.length>0){
          this.userStatusDescription= this.users[0].userStatus=='A'?'Active':'Deactivated';
        } 
        //DDMF-101 : End
        this.editMember = this.users;
        console.log(this.editMember, 'editMember');
    },
    error => {
      console.log(error, 'error');
    });
  }
  
  getData() {
  	console.log(this.url+this.userId);
  	var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);
    return this.http.get(this.url+this.userId,{ headers: headers });
  }
   goToURL(url){
		this.router.navigateByUrl(url);
		}
 
 
	
	
}



// WEBPACK FOOTER //
// ./src/app/manage-users/view-user/view-user.component.ts